import { FileData } from '@applyboard/school-applications-types-lib'
import { additionalDocumentTypeOptions } from '../utils'
import {
  RawApplicationPagePropsResponse,
  useGetApplicationPageProps,
} from './useGetApplicationPageProps'
import { get } from 'lodash'

type GetAdditionalDocumentsTypesProps = {
  files?: FileData
}

export function useGetAdditionalDocumentsTypes(props: GetAdditionalDocumentsTypesProps) {
  const { applicationPageProps } = useGetApplicationPageProps()

  const types: Record<string, { label: string }> = {}

  for (let [idx, { key, ...rest }] of Object.entries(additionalDocumentTypeOptions)) {
    const currentFile = Object.entries(props.files || {})
      .map(([, fileInfo]) => fileInfo)
      .find(file => file?.type === idx && file.activeRecord)
    if ((key && isEnabled(applicationPageProps, key)) || !key || currentFile) {
      types[idx] = rest
    }
  }

  return types
}

function isEnabled(props: RawApplicationPagePropsResponse['data'] | undefined, field: string) {
  return get(props, `specificFields.otherRequiredDocuments.documentTypes.${field}.enabled`)
}
